import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "checkbox-field" }
const _hoisted_2 = { class: "mt-6 mb-2" }

import { watch, Ref, ref, useTemplateRef } from 'vue';
  import api from "@/api";
  import { toast } from '@/lib/toast';
  import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
  import validation from "@/components/validation";

  interface CancelReason {
    id?: number;
    manualInput?: boolean;
    name?: string;
    placeHolder?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CancelByOrgReasonDlg',
  props: {
    procedure: { type: Object, required: true },
    open: { type: Boolean, required: true, default: false },
  },
  emits: ['procedureCanceled', 'update:open'],
  setup(__props, { emit: __emit }) {

  const props = __props

  const emit = __emit;

  const templateForm = useTemplateRef<any>('form')

  const cancelReasonSelected: Ref<CancelReason> = ref(null);
  const textareaSelected = ref(null);
  const textareaLabel = ref('');
  const showTextarea = ref(false);
  const showErrorMessage = ref(false);
  const showErrorTextareaMessage = ref(false);
  const isOpen = ref(false);
  const cancelReasons = ref<Array<CancelReason>>([]);

  /**
   * Получаем список причин отмены.
   */
  async function getVocabCancelReasons() {
    const result = await api.get('/vocab/cancel-reasons');

    cancelReasons.value = result;
  }

  async function agree() {
    const result = await templateForm.value?.validate();
    if (!result.valid) {
      if (!cancelReasonSelected.value?.id) {
        showErrorMessage.value = true;
        toast.error('Укажите, пожалуйста, причину отмены процедуры');
        return;
      }

      if (cancelReasonSelected.value.manualInput && !textareaSelected.value) {
        showErrorTextareaMessage.value = true;
        toast.error('Укажите причину отмены процедуры');
        return;
      }

      return;
    }

    try {
      let formData = new FormData();
      formData.append(
          'data',
          JSON.stringify({
            procedure_id: props.procedure?.id,
            cancel_reason_id: cancelReasonSelected.value.id,
            cancel_reason_message: textareaSelected.value,
          })
      );

      const result = await api.post('/procedures/cancel', formData);

      if (result) {
        toast.info('Отменена');
        emit('procedureCanceled');
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      close();
    }
  }

  const cancel = () => {
    close();
  }

  const close = () => {
    emit('update:open', false)

    cancelReasonSelected.value = null;
    textareaSelected.value = null;
    showErrorMessage.value = false;
    showErrorTextareaMessage.value = false;
  }

  watch(
      cancelReasonSelected,
      (cancelReason: CancelReason) => {
        showTextarea.value = !!cancelReason?.manualInput;

        if (cancelReason?.manualInput) {
          textareaLabel.value = cancelReason?.placeHolder;
        }
      },
  );

  watch(() => props.open, (newValue) => {
    isOpen.value = newValue;

    if (newValue) {
      getVocabCancelReasons();
    }
  });


return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_messages = _resolveComponent("v-messages")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(ConfirmDialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpen).value = $event)),
    "onUpdate:agree": agree,
    "onUpdate:cancel": cancel,
    "onUpdate:open": _cache[3] || (_cache[3] = $event => (isOpen.value = $event))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('Отмена процедуры')), 1 /* TEXT */)
    ]),
    content: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "py-0 px-0 mt-3 text-black content-label" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Вы действительно хотите отменить процедуру?')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_card_text, { class: "py-0 px-0 text-black content-label" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Укажите, пожалуйста, причину отмены процедуры.')), 1 /* TEXT */),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "error-color" }, "*", -1 /* HOISTED */))
        ]),
        _: 1 /* STABLE */
      }),
      (showErrorMessage.value && !cancelReasonSelected.value)
        ? (_openBlock(), _createBlock(_component_v_messages, {
            key: 0,
            active: "",
            class: "error-color mt-2",
            messages: ""
          }, {
            message: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Это поле обязательно для заполнения')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, [
        _createVNode(_component_v_form, { ref: "form" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancelReasons.value, (cancelReason, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: index,
                    name: cancelReason.name,
                    label: cancelReason.name,
                    value: cancelReason,
                    "true-icon": 'mdi-check mdi-18px',
                    "false-icon": 'void-checkbox',
                    modelValue: cancelReasonSelected.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cancelReasonSelected).value = $event)),
                    class: "spec-checkbox",
                    "hide-details": "",
                    required: "",
                    rules: [].concat(_unref(validation).required())
                  }, null, 8 /* PROPS */, ["name", "label", "value", "modelValue", "rules"]))
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_2, [
              (showTextarea.value)
                ? (_openBlock(), _createBlock(_component_v_textarea, {
                    key: 0,
                    rows: 3,
                    "auto-grow": "",
                    variant: "outlined",
                    placeholder: textareaLabel.value,
                    modelValue: textareaSelected.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textareaSelected).value = $event)),
                    maxlength: "255",
                    required: "",
                    "hide-details": "",
                    rules: [].concat(_unref(validation).required())
                  }, null, 8 /* PROPS */, ["placeholder", "modelValue", "rules"]))
                : _createCommentVNode("v-if", true),
              (showErrorTextareaMessage.value)
                ? (_openBlock(), _createBlock(_component_v_messages, {
                    key: 1,
                    active: "",
                    class: "error-color mt-2",
                    messages: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Это поле обязательно для заполнения')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})